/**
 * @typedef Skills
 * @returns {{
 *  list(slug: string): Promise,
 *  update(slug: string, payload: Array<{slug: string, value: unknown}>): Promise
 * }}
 */
export const Skills = axios => ({
  /**
   * Get skills list
   *
   * @param slug: string
   * @returns Promise
   */
  list(slug) {
    return axios.get(`/v1/profiles/${slug}/skills`)
  },
  /**
   * Update skills list
   *
   * @param slug: string
   * @returns Promise
   */
  update(slug, payload) {
    return axios.put(`/v1/profiles/${slug}/skills`, { skills: payload })
  }
})
